export enum FloodReportFileType {
    Upload = 0,
    External = 1,
}
